import React from 'react';
import cx from 'classnames';

import Icon from '../Icon';
import Text from '../Text';

import styles from './CheckboxItem.module.scss';
import usePresenter from './CheckboxItem.presenter';
import getProps from './CheckboxItem.props';
import { CheckboxItemCombinedProps } from './types';


const CheckboxItem: React.FC<CheckboxItemCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    disabled,
    buttonType,
    buttonForm,
    onClick,
    icon,
    text,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`checkboxItem${variantName}`];


  let componentView;

  switch (variantName) {
    case 'Disabled':
    case 'Checked':
    case 'Unchecked': {
      componentView = (
        <button
          disabled={disabled}
          type={buttonType}
          form={buttonForm}
          onClick={onClick}
          className={cx(currentStyle, className)}>
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}/>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </button>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default CheckboxItem;

